import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormFooter from "../../components/FormFooter";
import PageHeader from "../../components/PageHeader";
import { useNotification } from "../../contexts";
import { LIST_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import {
  getListing,
  updateListing,
  createReferral,
} from "../../services/listings";
import { ROUTES } from "../../constants";
import {
  getPropertyUnit,
  getPropertyUnitLeaseSettings,
} from "../../services/units";
import { getPropertyLease } from "../../services/leases";
import { getProperty } from "../../services/properties";
import Layout from "../../components/Layout";
import ListingUnitInfos from "../../components/ListingUnitInfos";
import ListingFileUpload from "../../components/ListingFileUpload";
import ShareDialog from "../../components/ShareDialog";

function AppPrivateListing(props) {
  const history = useHistory();
  const id = props.match.params?.id;
  const { dispatch } = useNotification();
  const [listing, setListing] = useState();
  const [property, setProperty] = useState();
  const [unit, setUnit] = useState();
  const [propertyLeaseSettings, setPropertyLeaseSettings] = useState();
  const [unitLeaseSettings, setUnitLeaseSettings] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [photoUrls, setPhotoUrls] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [referralCode, setReferralCode] = useState(false);

  useEffect(() => {
    getListing(id).then((data) => {
      setListing(data);
      setPhotoUrls(data.photoUrls);
    });
  }, [id]);

  useEffect(() => {
    if (listing && listing.id) {
      getProperty(listing.propertyId).then((data) => {
        setProperty(data);
      });
      getPropertyUnit(listing.propertyId, listing.unitId).then((data) => {
        setUnit(data);
      });
      getPropertyLease(listing.propertyId).then((data) => {
        setPropertyLeaseSettings(data);
      });
      getPropertyUnitLeaseSettings(listing.propertyId, listing.unitId).then(
        (data) => {
          setUnitLeaseSettings(data);
        }
      );
    }
  }, [listing]);

  useEffect(() => {
    if (property && unit && unitLeaseSettings) {
      setIsLoading(false);
    }
  }, [property, unit, unitLeaseSettings]);

  const onSubmit = (values) => {
    const payload = {
      ...listing,
      ...values,
      photoUrls,
      // ratings: {
      //   buildingLoudness: parseInt(values.ratings.buildingLoudness),
      //   cleanCommonAreasInside: parseInt(values.ratings.cleanCommonAreasInside),
      //   cleanWellMaintainedPropertyOutside: parseInt(
      //     values.ratings.cleanWellMaintainedPropertyOutside
      //   ),
      //   feltSafeInsideBuilding: parseInt(values.ratings.feltSafeInsideBuilding),
      //   feltSafeOutsideBuilding: parseInt(
      //     values.ratings.feltSafeOutsideBuilding
      //   ),
      //   overallLivingExperience: parseInt(
      //     values.ratings.overallLivingExperience
      //   ),
      //   responsiveLandlord: parseInt(values.ratings.responsiveLandlord),
      //   waterPressure: parseInt(values.ratings.waterPressure),
      // },
    };

    updateListing(payload).then(() => {
      dispatch({
        type: "add",
        notifications: [{ title: "Listing unit was update with success" }],
      });
      history.push(ROUTES.PRIVATE_LISTINGS);
    });
  };

  const removeListing = () => {
    updateListing({ ...listing, status: "REMOVED" })
    .then(() => {
      dispatch({
        type: "add",
        notifications: [{ title: "Listing have been removed with success" }],
      });
      history.push(ROUTES.PRIVATE_LISTINGS);
    }).error(() => {
        dispatch({
          type: "error",
          notifications: [{ title: "Error while deleting listing" }],
        })          
    });
  };

  const onClickCopyLink = () => {
    navigator.clipboard.writeText(referralCode);
    dispatch({ type: "add", notifications: [{ title: "Link copied" }] });
  };

  const onClickOpen = () => {
    createReferral(listing).then((response) => {
      setReferralCode(
        `${window.location.hostname}${ROUTES.PUBLIC_LISTINGS}/${response.referralCode}`
      );
      setIsOpen(true);
    });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const onClickReferalInput = (e) => {
    e.target.select();
  };

  return (
    <Layout isLoading={isLoading}>
      <PageHeader title={`Listing Unit ${unit?.number}`}>
        <Grid container spacing={1}>
          <Grid mr={2}>
            <Button variant="outlined" onClick={onClickOpen} size="small">
              Copy referal link
            </Button>
          </Grid>
          <Grid>
            <Button variant="contained" onClick={removeListing} size="small">
              Delete listing
            </Button>
          </Grid>
        </Grid>
      </PageHeader>
      <Box sx={{ gridArea: "main" }}>
        <ListingUnitInfos
          property={property}
          propertyLeaseSettings={propertyLeaseSettings}
          unit={unit}
          listing={listing}
          unitLeaseSettings={unitLeaseSettings}
        />
        <Formik
          initialValues={listing}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <ListingFileUpload
                photoUrls={photoUrls}
                onChange={setPhotoUrls}
              />
              <FormFooter
                isSave
                onCancel={() => history.push(ROUTES.PRIVATE_LISTINGS)}
              />
            </form>
          )}
        </Formik>
      </Box>

      <Dialog open={isOpen} onClose={handleClose} fullWidth={500}>
        <DialogTitle>Get link</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} mt={1}>
            <Grid xs={9}>
              <TextField
                fullWidth
                size="small"
                value={referralCode}
                onClick={onClickReferalInput}
              />
            </Grid>
            <Grid xs={3}>
              <Button onClick={onClickCopyLink} variant="text">
                Copy link
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}

export default AppPrivateListing;
